import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@sharedcommon/services/user.service';

@Directive({
    selector: '[hasRights]'
})
export class HasRightsDirective {

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private userService: UserService) { }

    @Input() set hasRights(rights: string[]) {
        if (rights && (this.userService.hasRights(rights) || rights.length === 0)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            // Else remove template from DOM
            this.viewContainer.clear();
        }
    }

}
